export default "__VITE_PUBLIC_ASSET__8b1ff56d__"